import React, { useEffect, useRef } from 'react';
import BranTokensWalletContent from './bran-tokens-wallet-content';
import { useTranslation } from 'react-i18next';

interface BranTokensWalletProps{
    open: boolean
    setOpen: (open: boolean) => void
}

const BranTokensWallet: React.FC<BranTokensWalletProps> = ({ open, setOpen }) => {
    const modalRef = useRef<HTMLDivElement | null>(null);
    const closeRef = useRef<HTMLButtonElement | null>(null);
    const openRef = useRef<HTMLButtonElement | null>(null);
    const { t } = useTranslation();

    useEffect(() => {
        if(open) openRef.current?.click();
        else closeRef.current?.click();
    }, [open]);

    
    useEffect(() => {
        const handleModalClose = () => {
            setOpen(false)
        };
    
        const modalLikesElement = document.getElementById(`modal-bran-token`);

        if (modalLikesElement) 
            modalLikesElement.addEventListener("hidden.bs.modal", handleModalClose);

        return () => {
            if (modalLikesElement)
                modalLikesElement.removeEventListener("hidden.bs.modal", handleModalClose);
        };
    }, [open]);


    return (
        <>
            <div className="col-10">
                    <div className="modal fade" id={`modal-bran-token`} aria-hidden="true">
                    <div className="modal-dialog cover-mobile">
                        <div id="username-suggestions"></div>
                        <div className="modal-content" ref={modalRef}>
                            <div className="modal-header modal-header-add-post" style={{ borderBottom: "0!important" }}>
                                <h3 className="modal-title user-select-none" id={`modal-bran-token`}>&nbsp;</h3>
                                <button ref={closeRef} type="button" className="btn-close svg-icons-color btn-dark" data-bs-dismiss="modal" aria-label="Close"></button>
                                <button className="d-none" ref={openRef} data-bs-toggle="modal" data-bs-target={`#modal-bran-token`}>a</button>
                            </div> 
                            <div className="modal-body modal-body-bran-wallet" style={{ minHeight: 150}}>
                                <BranTokensWalletContent/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BranTokensWallet;